export default "__VITE_ASSET__1XMh4hZ8__"